export const footerData = [
  {
    key: 1,
    title: "Face visible",
    description:
      "Your face should be clearly visible, without sunglasses or heavy filters",
  },
  {
    key: 2,
    title: "Appropriate background",
    description: "Avoid blurry, dark, or heavily edited backgrounds",
  },
  {
    key: 3,
    title: "Image resolution & format",
    description:
      "Recommended 1080x1920 pixels or higher for better quality in 4*6 ratio.",
  },
  {
    key: 4,
    title: "Solo photo",
    description:
      "Only you should be in the picture (no group photos or collages).",
  },
];
